import { useIntl } from 'react-intl';

import type { TooltipProps } from 'recharts';
import type { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

function StatisticsOverviewTooltip<TValue extends ValueType, TName extends NameType>({
    active,
    payload,
    label,
}: TooltipProps<TValue, TName>) {
    const { formatNumber } = useIntl();

    if (active && payload && payload.length) {
        return (
            <div className="w-full max-w-48 rounded-sm border bg-white/90 p-2 text-sm shadow-xs">
                <p className="font-medium text-gray-500">{label}</p>
                {payload.map((entry) => {
                    return (
                        <p key={Math.random()} className="font-medium text-gray-800" style={{ color: entry.color }}>
                            {entry.name}:{' '}
                            {entry.name && entry.dataKey === 'amount'
                                ? formatNumber(Number(entry.value) / 100, {
                                      style: 'currency',
                                      currency: entry?.payload?.currency,
                                  })
                                : entry.value}
                        </p>
                    );
                })}
            </div>
        );
    }

    return null;
}

export { StatisticsOverviewTooltip };
